import { createLadeskChat } from '../components/ladesk.js';

// LaDesk chat button id, taken from the LaDesk admin.
const CHAT_ID = '2k8f2cqz';

// The card at the bottom of the screen, plus the "Contact Live Chat" calls to
// action spread over the landings.
const TRIGGERS = '#supportChat, #trigger_support_chat, .trigger_support_chat';

export function supportChat () {
	const chat = createLadeskChat(CHAT_ID);

	$(document).on('click', TRIGGERS, function (e) {
		e.preventDefault();
		chat.open();
	});

	// The card's trigger is a div with role="button", so it needs Enter/Space
	// wired up by hand.
	$(document).on('keydown', TRIGGERS, function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			$(this).trigger('click');
		}
	});

	if (window.location.search.indexOf('init-live-help') > -1) {
		chat.open();
	}
}
